requestAnimationFrame(() => {
  if (!window.popupMenuJsLoaded) {
    themeBase.onDOMContentLoadedTrigger(() => {
      const menuPopupButton = document.querySelector('.js-popup-menu-button');

      if (menuPopupButton) {
        class MenuPopup {
          constructor() {
            themeBase.onDOMContentLoadedTrigger(() => {
              this.onWindowResize = this.onWindowResize.bind(this);
              this.onMenuClick = this.onMenuClick.bind(this);
              this.onMenuWrapClick = this.onMenuWrapClick.bind(this);
              this.show = this.show.bind(this);
              this.hide = this.hide.bind(this);
              this.documentKeyPress = this.documentKeyPress.bind(this);
              this.onMenuItemEnter = this.onMenuItemEnter.bind(this);
              this.onMenuItemLeave = this.onMenuItemLeave.bind(this);
              this.menuWrap = document.getElementById('jsPopupMenuWrapper');
              this.hoveredMenuItems = [];
              this.init();
            });
          }

          subscribeEvents() {
            if (this.subscribed) return;

            delegate(document, 'mouseover', '.popup-menu__list-item:not(.active)', this.onMenuItemEnter);
            delegate(document, 'mouseleave', '.popup-menu__list-item:not(.active)', this.onMenuItemLeave);
            delegate(document, 'mouseover', '.popup-menu__submenu-item', this.onMenuItemEnter);
            delegate(document, 'mouseleave', '.popup-menu__submenu-item', this.onMenuItemEnter);
            delegate(document, 'click', '#jsPopupMenu', this.onMenuClick);
            delegate(document, 'click', '#jsPopupMenuWrapper', this.onMenuWrapClick);

            window.addEventListener('throttle30fpsResize', this.onWindowResize);
            document.addEventListener("keydown", this.documentKeyPress);

            this.subscribed = true;
          }

          unsubscribeEvents() {
            delegate(document, 'mouseover', '.popup-menu__list-item:not(.active)', this.onMenuItemEnter);
            delegate(document, 'mouseleave', '.popup-menu__list-item:not(.active)', this.onMenuItemLeave);
            delegate(document, 'mouseover', '.popup-menu__submenu-item', this.onMenuItemEnter);
            delegate(document, 'mouseleave', '.popup-menu__submenu-item', this.onMenuItemEnter);
            document.removeEventListener("click", this.onMenuClick);
            document.removeEventListener("click", this.onMenuWrapClick);

            window.removeEventListener('throttle30fpsResize', this.onWindowResize);
            document.removeEventListener("keydown", this.documentKeyPress);
          }

          init() {
            this.menu = document.getElementById('jsPopupMenu');
            this.asyncMenuItems = document.querySelectorAll('#jsPopupMenu [data-async-item]');
            this.show();
          }

          documentKeyPress(e) {
            if (e.which === 27 || e.keyCode === 27) {
              this.hide();
            }
          }

          removeFromHoverMenuArr(e) {
            this.hoveredMenuItems = this.hoveredMenuItems.filter((t) => t.el !== e);
          }

          onMenuItemEnter(e) {
            const t = e.target;
            this.currentHoveredMenuItem = t;
            const hasSubmenuClass = t.classList.contains("popup-menu__submenu-item") || e.target.closest(".popup-menu__submenu-item");
            this.hoveredMenuItems.push({
              el: t,
              time: Date.now()
            });

            if (hasSubmenuClass) {
              e.stopPropagation();
            }

            this.hoverTimeout = setTimeout(() => {
              const hoveredItem = this.hoveredMenuItems.find(item => item.el === t);
              const menuElement = t;

              if (this.currentHoveredMenuItem === t && hoveredItem) {
                if (hasSubmenuClass) {
                  const submenuItem = menuElement.classList.contains("popup-menu__submenu-item") ? menuElement : e.target.closest(".popup-menu__submenu-item");
                  document.querySelectorAll(".popup-menu__submenu-item").forEach(item => item.classList.remove("active"));
                  submenuItem.classList.add("active");
                } else {
                  document.querySelectorAll(".popup-menu__list-item, .popup-menu__submenu-item").forEach(item => item.classList.remove("active"));

                  const listItem = menuElement.closest(".popup-menu__list-item");
                  const submenuItem = listItem.querySelector(".popup-menu__submenu-item.popup-menu__has-submenu");

                  listItem.classList.add("active");
                  submenuItem && submenuItem.classList.add("active");
                }

                this.removeFromHoverMenuArr(t);
              }
            }, 150);
          }

          onMenuItemLeave(e) {
            const t = e.currentTarget;
            const n = this.hoveredMenuItems.find((el) => el.el === t);

            if (n) {
              if (Date.now() - n.time < 150) {
                this.removeFromHoverMenuArr(t);
              }
            }
          }

          onMenuClick(e) {
            if (e.target === this.menu) {
              this.hide();
            }
          }

          onMenuWrapClick(e) {
            if (e.target === this.menuWrap) {
              this.hide();
            }
          }

          show() {
            this.menuWrap.classList.add("active");
            this.initMenuPosition();
            this.subscribeEvents();
            themeBase.freezeScroll({
              additionalClass: 'popup-menu-opening'
            });
          }

          hide() {
            this.menuWrap.classList.remove("active");
            document.querySelectorAll(".popup-menu__list-item, .popup-menu__submenu-item").forEach(item => item.classList.remove("active"));
            themeBase.unfreezeScroll({
              additionalClass: 'popup-menu-opening'
            });
          }

          initMenuPosition() {
            this.menu.style.setProperty('--menu-align-offset-top', `${Math.floor(getLogicalRect(menuPopupButton).bottom) / 10}rem`);
          }

          onWindowResize() {
            this.initMenuPosition();
          }
        }

        let menuWrap;
        let menuPopup;

        menuPopupButton.addEventListener('click', () => {
          menuWrap = menuWrap || document.querySelector('#jsPopupMenuWrapper');

          if (menuPopup !== undefined) {
            menuWrap.classList.contains('active') ? menuPopup.hide() : menuPopup.show();
          } else {
            menuPopup = new MenuPopup();
          }
        });
      }

    });
  }

  window.popupMenuJsLoaded = true;
});